import type { ButtonHTMLAttributes } from 'react';
import './Button.css';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

/**
 * Einziger Knopf-Stil der Marke: gefuellt, Ton-Akzent.
 * Zustaende sind Farbwechsel (--accent -> --accent-hover -> --accent-press),
 * keine Transformationen, kein Skalieren - siehe Designbriefing.
 */
export function Button({ className, ...props }: ButtonProps) {
  const classes = ['button', className].filter(Boolean).join(' ');
  return <button className={classes} {...props} />;
}
